import BaseService from './base.service';

const baseService = new BaseService('county');

export default {
  findListByCountryId: (countryId: number) => baseService.get(`findList/${countryId}`),
};
